import {
  GET_LICENSES_SUBSCRIPTION_LIST,
  GET_LICENSES_SUBSCRIPTION_LIST_FAILURE,
  GET_LICENSES_SUBSCRIPTION_LIST_SUCCESS,
  GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST,
  GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST_FAILURE,
  GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST_SUCCESS,
  REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW,
  REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW_SUCCESS,
  REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW_FAILURE,
  CONFIRM_SUBSCRIPTION_LICENSES_ORDER,
  CONFIRM_SUBSCRIPTION_LICENSES_ORDER_SUCCESS,
  CONFIRM_SUBSCRIPTION_LICENSES_ORDER_FAILURE,
  UPDATE_SUBSCRIPTION_LICENSES_ORDER,
  UPDATE_SUBSCRIPTION_LICENSES_ORDER_SUCCESS,
  UPDATE_SUBSCRIPTION_LICENSES_ORDER_FAILURE,
  UNASSIGN_LICENSE_FROM_USER,
  UNASSIGN_LICENSE_FROM_USER_SUCCESS,
  UNASSIGN_LICENSE_FROM_USER_FAILURE,
  GET_SUBSCRIPTION_PRODUCT_LIST,
  GET_SUBSCRIPTION_PRODUCT_LIST_SUCCESS,
  GET_SUBSCRIPTION_PRODUCT_LIST_FAILURE,
  GET_USER_LICENCE_LIST,
  GET_USER_LICENCE_LIST_SUCCESS,
  GET_USER_LICENCE_LIST_FAILURE,
} from "./actionType";

// initial data
const INIT_STATE = {
  licensesSubscriptionList: [],
  licenseSubscriptionListLoading: false,
  licenseSubscriptionListError: false,
  licensesSubscriptionProductList: [],
  licenseSubscriptionProductListLoading: false,
  licenseSubscriptionProductListError: false,
  subscriptionLicensesOrderPreview: [],
  subscriptionLicensesOrderPreviewLoading: false,
  subscriptionLicensesOrderPreviewError: false,
  confirmSubscriptionLicensesOrder: [],
  confirmSubscriptionLicensesOrderLoading: false,
  confirmSubscriptionLicensesOrderError: false,
  updateSubscriptionLicensesOrder: [],
  updateSubscriptionLicensesOrderLoading: false,
  updateSubscriptionLicensesOrderError: false,
  unassignLicenseFromUser: [],
  unassignLicenseFromUserLoading: false,
  unassignLicenseFromUserError: false,
  subscriptionProductList: [],
  subscriptionProductListLoading: false,
  userLicenceList: [],
  loadingUserLicenceList: false,
  userLicenceListError: false,
};

const ManageLicense = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LICENSES_SUBSCRIPTION_LIST:
      return {
        ...state,
        licenseSubscriptionListLoading: true,
        licenseSubscriptionListError: false,
      };
    case GET_LICENSES_SUBSCRIPTION_LIST_SUCCESS:
      return {
        ...state,
        licenseSubscriptionListLoading: false,
        licenseSubscriptionListError: false,
        licensesSubscriptionList: action.payload,
      };
    case GET_LICENSES_SUBSCRIPTION_LIST_FAILURE:
      return {
        ...state,
        licenseSubscriptionListLoading: false,
        licenseSubscriptionListError: true,
      };
    case GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST:
      return {
        ...state,
        licenseSubscriptionProductListLoading: true,
      };
    case GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        licenseSubscriptionProductListLoading: false,
        licensesSubscriptionProductList: action.payload,
      };
    case GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST_FAILURE:
      return {
        ...state,
        licenseSubscriptionProductListLoading: false,
      };
    case REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW_SUCCESS:
      return {
        ...state,
        subscriptionLicensesOrderPreviewLoading: false,
        subscriptionLicensesOrderPreview: action.payload,
      };
    case REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW_FAILURE:
      return {
        ...state,
        subscriptionLicensesOrderPreview: action.payload,
      };
    case REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW:
      return {
        ...state,
        subscriptionLicensesOrderPreviewLoading: true,
      };
    case CONFIRM_SUBSCRIPTION_LICENSES_ORDER:
      return {
        ...state,
        confirmSubscriptionLicensesOrderLoading: true,
      };
    case CONFIRM_SUBSCRIPTION_LICENSES_ORDER_SUCCESS:
      return {
        ...state,
        confirmSubscriptionLicensesOrderLoading: false,
        confirmSubscriptionLicensesOrder: action.payload,
      };
    case CONFIRM_SUBSCRIPTION_LICENSES_ORDER_FAILURE:
      return {
        ...state,
        confirmSubscriptionLicensesOrderLoading: false,
        confirmSubscriptionLicensesOrder: action.payload,
      };
    case UPDATE_SUBSCRIPTION_LICENSES_ORDER:
      return { ...state, updateSubscriptionLicensesOrderLoading: true };
    case UPDATE_SUBSCRIPTION_LICENSES_ORDER_SUCCESS:
      return {
        ...state,
        updateSubscriptionLicensesOrderLoading: false,
        updateSubscriptionLicensesOrder: action.payload,
      };
    case UPDATE_SUBSCRIPTION_LICENSES_ORDER_FAILURE:
      return {
        ...state,
        updateSubscriptionLicensesOrderLoading: false,
        updateSubscriptionLicensesOrder: action.payload,
      };
    case UNASSIGN_LICENSE_FROM_USER:
      return { ...state, unassignLicenseFromUserLoading: true };
    case UNASSIGN_LICENSE_FROM_USER_SUCCESS:
      return {
        ...state,
        unassignLicenseFromUserLoading: false,
        unassignLicenseFromUser: action.payload,
      };
    case UNASSIGN_LICENSE_FROM_USER_FAILURE:
      return {
        ...state,
        unassignLicenseFromUserLoading: false,
        unassignLicenseFromUser: action.payload,
      };
    case GET_SUBSCRIPTION_PRODUCT_LIST:
      return {
        ...state,
        subscriptionProductListLoading: true,
      };
    case GET_SUBSCRIPTION_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        subscriptionProductListLoading: false,
        subscriptionProductList: action.payload,
      };
    case GET_SUBSCRIPTION_PRODUCT_LIST_FAILURE:
      return {
        ...state,
        subscriptionProductListLoading: false,
      };
    case GET_USER_LICENCE_LIST:
      return {
        ...state,
        loadingUserLicenceList: true,
        userLicenceListError: false,
      };
    case GET_USER_LICENCE_LIST_SUCCESS:
      return {
        ...state,
        loadingUserLicenceList: false,
        userLicenceListError: false,
        userLicenceList: action.payload,
      };
    case GET_USER_LICENCE_LIST_FAILURE:
      return {
        ...state,
        loadingUserLicenceList: false,
        userLicenceListError: true,
      };

    default:
      return state;
  }
};

export default ManageLicense;
